let defaultProvider

/**
 * Stores the default generation provider served by the backend
 * (react_props_three_d_studio -> defaultGenerationProvider). It is kept in module
 * scope instead of the store so a store reset (resetOpenedModelState) does not
 * drop it and leave the session without a default mid-flight.
 *
 * @param {string} provider - Provider id chosen by the backend.
 */
export const setDefaultGenerationProvider = (provider) => {
  defaultProvider = provider
}

/**
 * Resolves the model generation provider to activate when none is active yet.
 *
 * @param {string[]} providers - Providers eligible for the current generation action.
 * @returns {string} The backend default, or the first eligible provider when the
 *   default is not available for this action and settings combination.
 */
export const resolveInitialGenerationProvider = (providers) => (
  providers.includes(defaultProvider) ? defaultProvider : providers[0]
)
